import { Component, Input, OnInit } from "@angular/core";
import {
  PageViewModel,
  SectionTypeNameEnum,
  SectionViewModel,
} from "src/domain/client";
import { ModelAndDealerService } from "src/services/model-and-dealer.service";

@Component({
  selector: "vw-page",
  templateUrl: "./page.component.html",
})
export class PageComponent implements OnInit {
  @Input({ required: true }) page!: PageViewModel | null;
  @Input() alwaysFillNav: boolean = false;
  @Input() showDealerInformation: boolean = false;

  footerSection?: SectionViewModel;

  constructor(public modelAndDealerService: ModelAndDealerService) {}

  ngOnInit(): void {
    this.footerSection =
      (this.page &&
        this.page.sections &&
        this.page.sections.length &&
        this.page.sections.find(
          (_) => _.sectionTypeName === SectionTypeNameEnum.Footer,
        )) ||
      undefined;
  }
}
